
import HeaderTitleWithSearch from "@/components/HeaderTitleWithSearch.vue";
import ProductCard from "@/components/ProductCard.vue";
import BackAndCancelFooter from "@/components/BackAndCancelFooter.vue";
import { useStore } from "@/store";
import { defineComponent, computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "SelectProudctView",
  components: { HeaderTitleWithSearch, ProductCard, BackAndCancelFooter },
  async setup() {
    const router = useRouter();
    const { t } = useI18n();
    const store = useStore();
    const searchText = ref("");
    const products = computed(() => store.getters.productsByPriceType);
    const productsView = computed(() => {
      if (searchText.value.length < 2) {
        return [];
      }
      return products.value.filter((x) =>
        x.name.toLowerCase().includes(searchText.value.toLowerCase())
      );
    });
    function onSelect(productId: number) {
      router.push({
        name: "productPriceLines",
        params: { productId: productId },
      });
    }
    function changeSearchText(newValue: string) {
      searchText.value = newValue;
    }

    const orderProducts = computed(() =>
      store.state.order.products.map((x) => x.id)
    );

    return {
      t,
      products,
      orderProducts,
      onSelect,
      changeSearchText,
      productsView,
      searchText,
    };
  },
});
